export default "__VITE_ASSET__I2FXzQ8$__"